import { render, staticRenderFns } from "./TableHeaderCell.vue?vue&type=template&id=38addd78&scoped=true&"
import script from "./TableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCell.vue?vue&type=style&index=0&id=38addd78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38addd78",
  null
  
)

export default component.exports